<template>
  <main>
    <section class="fk-contents" v-if="searchResult===1">
      <h2 class="title-lv2 mb20">{{text.SelectReceive}}</h2>
      <div class="mod-normal-box" v-for="(store, index) in storeList" :key="index">
        <p class="store-name"><img :src="store.image_url" :alt="getBrandName(store.store_name)" v-if="store.image_url!==null"><span class="name">{{store.store_name}}</span></p>
        <p class="store-address">{{store.address}}</p>
        <p class="store-address" style="font-weight:bold; margin-bottom:5px;">{{$t('StoreInfo.ReceptionTime')}}</p>
        <dl class="store-business-hours" style="margin-top:0;" v-if="store.has_morning_menu===true">
          <dt>{{text.Morning}}</dt>
          <dd>{{store.outputs.morningTime}}</dd>
        </dl>
        <dl class="store-business-hours">
          <dt>{{text.Grand}}</dt>
          <dd>{{store.outputs.grandTime}}</dd>
        </dl>
        {{text.Note}}
        <br v-if="!store.can_use_mfcard" /><span v-if="!store.can_use_mfcard" style="color:#c00823;">{{text.CannotMFC}}</span>
        <p class="btn-store-choice"><input type="submit" :value="outputButtonLabel(store.is_closed)" class="btn-base btn-main" :disabled="store.is_closed" @click.prevent="execSelectStore(store.store_cd)"></p>
      </div>

      <div class="mod-normal-box" v-if="isNotFound">
        <p>{{text.NotFound}}</p>
      </div>

      <ul class="mod-pager" v-if="model.visible.paging">
        <li class="prev" v-if="model.visible.prev"><button type="button" @click="execPaging('prev')">{{text.Previous}}</button></li>
        <li class="next" v-if="model.visible.next"><button type="button" @click="execPaging('next')">{{text.Next}}</button></li>
      </ul>

      <div class="mod-select-area">
        <div class="mod-form-block">
          <span class="label">{{text.SelectArea}}</span>
          <select name="" id="" v-model="model.selected.area_cd">
            <option value="">{{text.AreaSearch}}</option>
            <option v-for="(area, index) in areaList" :key="index" :value="area.area_cd">{{area.area_name}}</option>
          </select>
        </div>
        <p class="mod-form-btn"><input type="button" :value="text.SelectAbove" class="btn-base btn-sub" @click="execSelectArea()"></p>
      </div>
    </section>
    <section class="fk-contents" v-if="searchResult===9">
      <h2 class="title-lv2 mb20">{{text.SelectReceive}}</h2>
      <p class="text-error">{{text.StoreNotFound}}</p>
      <p class="mod-form-btn"><input type="button" :value="text.Return" class="btn-base btn-negative btn-quit" @click="execReturn"></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import GeolocationMixin from '@/mixins/GeolocationMixin'
import StoreUtilMixin from '@/mixins/StoreUtilMixin'
export default {
  name: 'FKMOStoreList',
  mixins: [ CommonMixin, ValidationMixin, DisplayErrorMixin, GeolocationMixin, StoreUtilMixin ],
  data () {
    return {
      areaList: [],
      storeList: [],
      isNotFound: false,
      searchResult: 0, // 0=検索前,1=found,9=notfound
      text: {
        SelectReceive: null,
        LastOrder: null,
        Morning: null,
        Grand: null,
        Next: null,
        Select: null,
        NotFound: null,
        NotReception: null,
        Previous: null,
        SelectArea: null,
        AreaSearch: null,
        SelectAbove: null,
        StoreNotFound: null,
        Note: null,
        CannotMFC: null,
        Return: null
      },
      model: {
        selected: {
          area_cd: ''
        },
        visible: {
          next: true,
          prev: true,
          paging: true
        }
      },
      paging: {
        maxPages: null,
        totalCounts: null
      }
    }
  },
  computed: {
    getStoreSearchParams () {
      return this.$store.getters.storeSearchParams
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    },
    getCart () {
      return this.$store.getters.cart
    }
  },
  watch: {
    $route (to, from) {
      let page = 1
      if (to.query.page !== undefined) {
        page = to.query.page
      }
      this.getStoreList(page)
    }
  },
  methods: {
    execSelectStore: function (storeCd) {
      if (this.getDisabledButton) {
        return false
      }
      this.$store.dispatch('setDisabledButton', true)

      // storeCdの店舗を検索して取得する
      let selectStore
      this.storeList.filter(function (store) {
        if (store.store_cd === storeCd) {
          selectStore = store
        }
      })

      // 選択した店舗が休業中の場合は処理を停止する
      if (selectStore.isClosed) {
        this.$store.dispatch('setDisabledButton', false)
        return false
      }

      // カートを空にする判定
      this.checkStoreCode(storeCd)

      // 表示データを生成する
      const outputs = this.makeDisplayInfo(selectStore)
      selectStore = Object.assign(selectStore, outputs)
      this.$store.commit('setSelectStore', selectStore)

      // 営業時間中判定
      this.setIsSales(this.$parent.fkmoTimer, selectStore)
      // 営業時間帯判定
      this.setIsAcceptingMenu(this.$parent.fkmoTimer, selectStore)
      // メニューカテゴリー種別を設定
      this.setMenuCategoryType()

      this.$store.dispatch('setDisabledButton', false)
      this.$router.push({ name: 'ReceiveMethod' })
    },
    execSelectArea: function () {
      if (this.getDisabledButton) {
        return false
      }
      this.$store.dispatch('setDisabledButton', true)

      // 未選択の時は遷移させない
      if (this.model.selected.area_cd === '') {
        this.$store.dispatch('setDisabledButton', false)
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_031'))
        return false
      }
      this.$store.dispatch('setDisabledButton', true)

      this.$store.dispatch('setStoreSearchParams', {
        latitude: null,
        longitude: null,
        area_cd: String(this.model.selected.area_cd),
        type: 2
      })
      this.$router.push({
        name: 'StoreList',
        query: {
          q: this.CryptoJS.AES.encrypt(String(this.model.selected.area_cd), process.env.VUE_APP_AREACD_HASHKEY).toString()
        }
      })
      this.$store.dispatch('setDisabledButton', false)
    },
    // ページング
    execPaging: function (direction) {
      // 初期化
      let page = 1

      if (this.getDisabledButton) {
        return false
      }
      this.$store.dispatch('setDisabledButton', true)

      // クエリパラメータpageを取得する
      let currentPage = this.$route.query.page
      if (currentPage === null || currentPage === undefined || currentPage < 1) {
        currentPage = 1
      } else {
        currentPage = Number(currentPage)
      }

      switch (direction) {
        case 'next':
          page = currentPage + 1
          if (page > this.maxPages) {
            page = this.maxPages
          }
          break
        case 'prev':
          page = currentPage - 1
          if (page < 1) {
            page = 1
          }
          break
        default:
          break
      }

      this.$router.push({
        name: 'StoreList',
        query: { page }
      }, () => {}, () => {})

      this.$store.dispatch('setDisabledButton', false)
    },
    execReturn: function () {
      this.$router.push({ name: 'StoreSelect' })
    },
    getBrandName: function (type) {
      switch (type) {
        case 1:
          return this.getCompanyName('FK')
        case 2:
          return this.getCompanyName('WFK')
        default:
          return ''
      }
    },
    getStoreList: function () {
      const _that = this
      let page = 1

      if (this.$route.query.page !== null && this.$route.query.page !== undefined && this.$route.query.page > 1) {
        page = this.$route.query.page
      }

      // パラメータを初期化
      let params = {
        type: this.getStoreSearchParams.type,
        latitude: this.getStoreSearchParams.latitude,
        longitude: this.getStoreSearchParams.longitude,
        area_cd: this.getStoreSearchParams.area_cd,
        page,
        language: sessionStorage.getItem('lang')
      }
      // storeからarea_cdを取り出す
      if (this.getStoreSearchParams.area_cd !== null) {
        params.area_cd = String(this.getStoreSearchParams.area_cd)
      }
      this.callApi('StoreList',
        params
      )
      // this.axios.get('/static/stub/StoreList/store_list.json')
        .then(function (res) {
          if (res.data.result) {
            _that.storeList = res.data.value.store_list
            // 表示データを生成
            for (let i = 0; i < _that.storeList.length; i++) {
              // TODO 特殊な営業時間に対する考慮ができていない。例えば10:00-6:00,7:00-10:00パターン（1時間の中抜け閉店がある場合）
              const outputs = _that.makeDisplayInfo(_that.storeList[i])
              _that.storeList[i] = Object.assign(_that.storeList[i], outputs)
            }
            // 最大ページをセット
            _that.paging.maxPages = res.data.value.max_pages
            _that.paging.totalCounts = res.data.value.total_counts
            // サーバー時間をセット
            _that.$store.dispatch('setServerTime', res.data.value.server_time)
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch(function (error) {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          // APIリクエスト後のstoreListの件数をチェックする
          if (_that.storeList.length === 0) {
            _that.isNotFound = true
            _that.searchResult = 9
          } else {
            _that.isNotFound = false
            _that.searchResult = 1
          }
          _that.setVisible()
          _that.setDisabledButton(false)
        })
    },
    getAreaList: function () {
      const _that = this

      this.callApi('AreaList',
        {
          language: sessionStorage.getItem('lang')
        }
      )
      // this.axios.get('/static/stub/StoreSelect/arealist.json')
        .then(function (res) {
          if (res.data.result) {
            _that.areaList = res.data.value.area_list
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch(function (error) {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.setDisabledButton(false)
        })
    },
    // 選択ボタンのラベル出力を制御する
    outputButtonLabel: function (isClosed) {
      // 休業中フラグが立っている
      if (isClosed) {
        return this.text.NotReception
      }
      return this.text.Select
    },
    setVisible: function () {
      const current = this.$route.query.page

      if (this.paging.maxPages <= 1) {
        this.model.visible.paging = false
      } else {
        this.model.visible.paging = true
        if (current === null || current === undefined || Number(current) <= 1) {
          // 前へボタン非表示
          this.model.visible.next = true
          this.model.visible.prev = false
        } else if (Number(current) > 1 && Number(current) < this.paging.maxPages) {
          this.model.visible.next = true
          this.model.visible.prev = true
        } else {
          // 次へボタン非表示
          this.model.visible.next = false
          this.model.visible.prev = true
        }
      }
    },
    initView: function () {
      // マウント後に画面出力する文字列を設定する
      this.text.SelectReceive = this.$i18n.t('ShopSearch.SelectReceive')
      this.text.LastOrder = this.$i18n.t('StoreInfo.LastOrder')
      this.text.Morning = this.$i18n.t('StoreInfo.Morning')
      this.text.Grand = this.$i18n.t('StoreInfo.Grand')
      this.text.Next = this.$i18n.t('General.Next')
      this.text.Select = this.$i18n.t('General.Select')
      this.text.NotFound = this.$i18n.t('ShopSearch.NotFound')
      this.text.NotReception = this.$i18n.t('ShopSearch.NotReception')
      this.text.Previous = this.$i18n.t('General.Previous')
      this.text.SelectArea = this.$i18n.t('ShopSearch.SelectArea')
      this.text.AreaSearch = this.$i18n.t('ShopSearch.AreaSearch')
      this.text.SelectAbove = this.$i18n.t('ShopSearch.SelectAbove')
      this.text.StoreNotFound = this.$i18n.t('ShopSearch.StoreNotFound')
      this.text.Note = this.$i18n.t('ShopSearch.Note')
      this.text.Return = this.$i18n.t('General.Return')
      this.text.CannotMFC = this.$i18n.t('ShopSearch.CannotMFC')
    },
    init: function () {
      this.getStoreList() // ページ初期化時は必ず1ページ目を取得
      this.getAreaList()
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
input[type=button], input[type=submit] {
  cursor: pointer;
}
input[type=button]:disabled, input[type=submit]:disabled {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreList.vue